import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchUsers = createAction(ACTION.FETCH_USERS.REQUEST, (params) => params);
export const fetchDetailUser = createAction(ACTION.FETCH_DETAIL_USERS.REQUEST, (userId, payload = {}) => ({...payload, userId}));
export const clearDetailUser = createAction(ACTION.CLEAR_DETAIL_USER_STATE, () => {});
export const clearState = createAction(ACTION.CLEAR_STATE);
